import ApiService from '../api.services';

const SroService = {
  status: async function (data) {
    try {
      const response = await ApiService.post(`/api/sro/status/graph`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  notdelivered: async function (data) {
    try {
      const response = await ApiService.post(`/api/sro/notdelivered`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  notdeliveredstatus: async function (data) {
    try {
      const response = await ApiService.post(`/api/sro/notdelivered/status`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default SroService;

export { SroService };

